module.exports = "<p>{{ message }}</p><span></span><span></span><span></span><span></span>\n";